var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"max-w-5xl mx-auto bg-white overflow-hidden shadow-xl pt-2 py-6 px-12"},[(_vm.addMenu)?_c('div',{staticClass:"relative"},[_vm._t("menu")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt-5"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }